import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';

export const PermissionsView = angular
  .module('acme.view.application.permissions', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.permissions.controllers',
    'acme.view.application.permissions.list',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.permissions',
      url: '/permissions',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'PermissionsController',
          templateUrl: 'views/application/views/permissions/permissions.tpl.html',
        },
      },
    });
  }).name;
